import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RoomdetailPage } from './roomdetail';

@NgModule({
  declarations: [
    RoomdetailPage,
  ],
  imports: [
    IonicPageModule.forChild(RoomdetailPage),
  ],
})
export class RoomdetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/roomdetail/roomdetail.module.ts